import { IPortfolio } from 'src/app/models/portfolios';
import { IAppState } from 'src/app/store/state/app.state';
import { InvestorService } from 'src/app/services/http/investor.service';
import { PortfoliosService } from './../../../services/http/portfolios.service';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { switchMap, map, catchError, concatMap, mergeMap } from 'rxjs/operators';
import { of, Subscription} from 'rxjs';
import * as GeneralNotificationActions from '../../global-notification/actions/global-notification.action';
import * as PortfoliosActions from './../actions/portfolios.actions';
import * as systemActions from '../../system/actions/system.actions';
import { Store } from '@ngrx/store';
import { MatDialog } from '@angular/material/dialog';
import { EntitySubType } from 'src/app/models/entityTypes';
import { AppConfig } from 'src/app/app.config';
import { SiteIds } from 'src/app/models/sites';
import { deduplicatingSwitchMap } from 'src/app/utils/deduplicatingSwitchMap';

@Injectable()
export class PortfoliosEffects {

  getKiwisaverEntitySubscription: Subscription;

  constructor(
    private store: Store<IAppState>,
    private actions$: Actions,
    private portfoliosService: PortfoliosService,
    private investorService: InvestorService,
    private dialog: MatDialog,
    private appConfig: AppConfig) { }

  getPortfolios$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(PortfoliosActions.PortfoliosActionTypes.GET_INVESTOR_PORTFOLIOS),
      deduplicatingSwitchMap((action: PortfoliosActions.GetInvestorPortfolios) => {
        
        let entitySubTypes: number[] = this.getInvestorSubTypesForPortfolioRetrieval();

        return this.portfoliosService.getInvestorPortfolios(entitySubTypes)
          .pipe(
            concatMap((res: IPortfolio[]) => {
              if (res) {
                return [new PortfoliosActions.GetInvestorPortfoliosSuccess(res)];
              } else {
                return of(new PortfoliosActions.GetInvestorPortfoliosFail("Selected Portfolio Data could not be retrieved"));
              }
            })
            , catchError((err) => {
              return of(
                new PortfoliosActions.GetInvestorPortfoliosFail(err.error),
                new systemActions.UpdateStatus({ passed: false, text: "Selected Portfolio Data could not be retrieved" })
              );
            })
          );
      })
    );
  });

  searchPortfolios$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(PortfoliosActions.PortfoliosActionTypes.SEARCH_PORTFOLIOS),
      deduplicatingSwitchMap((action: PortfoliosActions.SearchPortfolios) => {
        return this.portfoliosService.searchPortfolios(<string>action.payload)
          .pipe(
            map((res: any) => {
              if (res) {
                return new PortfoliosActions.SearchPortfoliosSuccess(res);
              }
            })
            , catchError((err) => {
              return of(
                new GeneralNotificationActions.NotificationErrorAction("Selected portfolio data could not be retrieved")
              );
            })
          );
      })
    );
  });

  getPortfolioPositions$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(PortfoliosActions.PortfoliosActionTypes.LOAD_PORTFOLIO_ENTITY),
      deduplicatingSwitchMap((action: PortfoliosActions.LoadPortfolioEntity) => {
        return this.portfoliosService.loadPortfolioEntity(action.payload)
          .pipe(
            concatMap((res: any) => {
              if (res) {
                return [
                  new PortfoliosActions.LoadPortfolioEntitySuccess(res)
                ];
              }
            })
            , catchError((err) => {
              return of(
                new GeneralNotificationActions.NotificationErrorAction("Selected Model Portfolio Data could not be retrieved")
              );
            })
          );
      })
    );
  });

  getPortfoliosForEntities$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(PortfoliosActions.PortfoliosActionTypes.LOAD_PORTFOLIOS_FOR_ENTITIES),
      deduplicatingSwitchMap((action: PortfoliosActions.LoadPortfoliosForEntities) => {
        return this.portfoliosService.loadPortfoliosForEntities(action.payload)
          .pipe(
            map((res: any) => {
              return new PortfoliosActions.LoadPortfoliosForEntitiesSuccess(res);
            }),
            catchError((err) => {
              return of(
                new GeneralNotificationActions.NotificationErrorAction("Failed to load portfolios for entities")
              );
            })
          );
      })
    );
  });

  getInvestorReferenceNumber$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(PortfoliosActions.PortfoliosActionTypes.GET_REFERENCE_NUMBER),
      mergeMap((action: PortfoliosActions.GetReferenceNumber) => {
        return this.investorService.getInvestorReferenceNumber(action.payload)
          .pipe(
            map((referenceNumber: string) => {
              if (referenceNumber) {
                return new PortfoliosActions.GetReferenceNumberSuccess(action.payload, referenceNumber);
              }
            }),
            catchError((err) => {
              return of(
                new GeneralNotificationActions.NotificationErrorAction("Investor reference number could not be retrieved"),
                new PortfoliosActions.GetReferenceNumberFail(action.payload)
              );
            })
          );
      })
    );
  });

  private getInvestorSubTypesForPortfolioRetrieval() : number[]{
    var entitySubTypes: number[] = [];
    const siteId = this.appConfig.getEnvironment().siteId;
    if (siteId && (siteId === SiteIds.INVESTNOW || siteId === SiteIds.EVIDENTIAL)) {
      entitySubTypes.push(EntitySubType.KiwiSaverInvestor)
    }
    return entitySubTypes;
  }
}

